module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hsPFvC/tc-custom/9780830869527.jpg?1696363259553",
      "alt": "This image is the cover for the book A Vision for the Aging Church"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Vision for the Aging Church\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Are we ready for the opportunities and challenges facing the aging church? Now is the time for the church to offer ministry to its increasing numbers of seniors and to benefit from ministry they can offer. In this book James M. Houston and Michael Parker issue an urgent call to reconceive the place and part of the elderly and seniors in the local church congregation. Confronting the idea that the aging are mostly a burden on the church, they boldly address the moral issues related to caring for them, provide examples of successful care-giving programs and challenge the church to restore broken connections across the generations. Cowritten by a noted theologian and an expert in the fields of social work and gerontology, this interdisciplinary book assesses our current cultural context and the challenges and opportunities we face. The authors show us that seniors aren't the problem. They are the solution.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James M. Houston, Michael Parker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Jim Houston (M.A., Edinburgh; D.Phil., Oxford) is founding principal, former chancellor, and emeritus professor of spiritual theology at Regent College in Vancouver, British Columbia. He is the author of some forty books, including "), _c('em', [_vm._v("I Believe in the Creator, The Transforming Friendship, In Search of Happiness, The Heart's Desire")]), _vm._v(" and "), _c('em', [_vm._v("The Mentored Life.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0